module.exports = __webpack_public_path__ + "assets/img/1_1697.711a291a.jpg";